module.exports = __webpack_public_path__ + "static/media/dot-loader.6ca3068a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dot-loader.gif
// module id = 1707
// module chunks = 0